import React, { useState, useContext, useEffect } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { LOGO, SITE_NAME } from '@/utils'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import {
    Badge,
    Button,
    Divider,
    ListItem,
    Menu,
    MenuItem,
    SwipeableDrawer,
} from '@material-ui/core'
import { styled } from '@material-ui/styles'
import AuthContext from '@/product/context/auth/authContext'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import CartContext from '@/product/context/cart/cartContext'
import AlertContext from '@/product/context/alert/alertContext'
import { handleRedirectInternal, useCustomMediaQuery } from '@/product/common/components'
import { getUserProfileErrorMessage } from '@/custom/common/components'

import './Header.css'
import AutopltContext from '@/product/context/autopilot/autopltContext'
import UserContext from '@/product/context/user/userContext'
import ProductContext from '@/product/context/product/productContext'
import BidHistory from '@/custom/components/organisms/BidHistory/popuphistory'
import LanguageSwitch from '../LanguageSwitch'
import BuynowContext from '@/product/context/buynow/buynowContext'
import PayContext from '@/product/context/payment/payContext'
import CreditContext from '@/product/context/credit/creditContext'
import OfflineContext from '@/product/context/offline/offlineContext'
import Loaders from '../Loaders'
import { Popover } from '@material-ui/core'
import { mapData } from '@/product/common/components'
import { useLocation } from 'react-router-dom'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CustomDialog from '@/custom/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useTranslation } from 'react-i18next'

const Header = () => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const commonContext = useContext(CommonContext)
    const customCommonContext = useContext(CustomCommonContext)
    const productContext = useContext(ProductContext)
    const payContext = useContext(PayContext)
    const cartContext = useContext(CartContext)
    const creditContext = useContext(CreditContext)
    const offlineContext = useContext(OfflineContext)
    const userContext = useContext(UserContext)
    const autopltContext = useContext(AutopltContext)
    const buynowContext = useContext(BuynowContext)
    const location = useLocation()
    const { t } = useTranslation()
    const { setAlert } = alertContext
    const {
        user,
        isAuthenticated,
        loadPendingCount,
        isAdmin,
        cartCount,
        logout,
        switchUser,
        login,
        responseStatus: responseStatusAuth,
        clearResponse: clearResponseAuth,
    } = authContext

    const [state, setState] = useState({
        right: false,
        top: false,
    })

    const formik = useFormik({
        initialValues: {
            user: '',
        },
        onSubmit: (values) => {},
    })
    const history = useHistory()
    const [anchormenu, setanchormenu] = useState(null)
    const [anchorcart, setanchorcart] = useState(null)
    const [toggleDialog, setToggleDialog] = useState(false)
    const [toggleUnpaid, setToggleUnpaid] = useState(false)

    const { responseStatus: responseStatusProduct, clearResponse: clearResponseProduct } =
        productContext
    const { responseStatus: responseStatusPayment, clearResponse: clearResponsePayment } =
        payContext

    const { responseStatus: responseStatusCart, clearResponse: clearResponseCart } = cartContext

    const {
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
        updateProfile,
    } = userContext
    const { responseStatus: responseStatusCredit, clearResponse: clearResponseCredit } =
        creditContext

    const { responseStatus: responseStatusOffline, clearResponse: clearResponseOffline } =
        offlineContext

    const { responseStatus: responseStatusAutoPlt, clearResponse: clearResponseAutoPlt } =
        autopltContext
    const invoiceContext = useContext(InvoiceContext)
    const { search_alluserinvoices, getAllSellerUserInvoices, getAllUserInvoices } = invoiceContext

    const {
        responseStatus: responseStatusBuyNow,
        clearResponse: clearResponseBuyNow,
        getAllCartProducts,
        search_allproducts,
    } = buynowContext

    const { searchValue, setSearchValue, isLoading } = commonContext
    const { setCurrentMembership, allBiddingPlan, membership } = customCommonContext
    const [searchText, setSearchText] = useState('')
    let [cartProducts, setCartProducts] = useState([])
    const [search, setSearch] = useState({})
    const [showAuction, setShowAuction] = useState(false)
    const [membershipPlan, setMembershipPlan] = useState('')

    const isUserProfileUpdated = user?.seniority ?? null
    const ERROR_MESSAGE = getUserProfileErrorMessage(user)

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    const changeDialogUnpaidStatus = () => {
        setToggleUnpaid(!toggleUnpaid)
    }

    useEffect(() => {
        if (isAuthenticated && user) {
            if (user.both_access || !user.admin) {
                getAllUserInvoices(
                    {
                        limit: 10,
                        page: 1,
                        checkout: 1,
                        // admin: 1,
                        action: 'allunpaid',
                        filters: {
                            active: {
                                value: '2',
                                type: 'notin',
                                field: 'b.active',
                            },
                            action: {
                                value: '',
                                type: 'in',
                                field: 'b.paid',
                            },
                        },
                    },
                    'userUnpaidInvoice',
                )
            }
        } else {
            setToggleUnpaid(false)
        }
    }, [user])
    useEffect(() => {
        if (
            search_alluserinvoices &&
            search_alluserinvoices.records?.length > 0 &&
            search_alluserinvoices.from == 'userUnpaidInvoice'
        ) {
            setToggleUnpaid(true)
        } else if (search_alluserinvoices && search_alluserinvoices.from == 'userUnpaidInvoice') {
            setToggleUnpaid(false)
        }
    }, [search_alluserinvoices])

    useEffect(() => {
        if (user?.membership) {
            if (user.membership_period === 'monthly') {
                setMembershipPlan('timeBidderPlan')
            } else if (user.membership_period === 'yearly') {
                setMembershipPlan('timeBidder')
            } else if (user.membership_period === 'five_yearly') {
                setMembershipPlan('timeBidder \r\n offer')
            }
        }
    }, [user])

    useEffect(() => {
        if (localStorage.getItem('token')) {
            if (
                isAuthenticated &&
                !isUserProfileUpdated &&
                !location.pathname.includes('/profile') &&
                (user?.admin || (!user?.admin && user?.membership))
            ) {
                // const hideToast = ['/login', '/registration', '/subscription']
                // if (!hideToast.some((keyword) => location.pathname.includes(keyword))) {
                // }

                if (!location.pathname === '/') {
                    setAlert(ERROR_MESSAGE, 'error')
                }

                handleRedirectInternal(history, 'account/profile')
                return
            }

            getAllCartProducts(search)
            if (isAuthenticated && user) {
                if (user.admin && !location.pathname.includes('/invoice')) {
                    getAllSellerUserInvoices({
                        limit: 10,
                        page: 1,
                        // orderby: 1,
                        checkout: 1,
                        admin: 1,
                        filters: {
                            active: {
                                value: '2',
                                type: 'notin',
                                field: 'b.active',
                            },
                            action: {
                                value: 'all',
                                type: 'in',
                                field: 'p.market_Status',
                            },
                            project_id: {
                                value: '',
                                type: 'in',
                                field: 'b.project_id',
                            },
                        },
                    })
                    // if (location.pathname == 'search' && !showAuction) {
                    // handleRedirectInternal(history, 'seller/lots/open')
                    // }
                }
                if (user.membership) {
                    if (allBiddingPlan && allBiddingPlan.length) {
                        let activePlan = allBiddingPlan.filter(
                            (value) => value.type === membershipPlan,
                        )
                        if (activePlan.length) {
                            setCurrentMembership(activePlan[0])
                        } else {
                            setCurrentMembership('')
                            if (!user.admin) {
                                // handleRedirectInternal(history, 'subscription')
                            }
                        }
                    }
                } else {
                    setCurrentMembership('')
                    if (
                        !user.admin &&
                        location.pathname != '/subscription' &&
                        !location.pathname.includes('/successPay') &&
                        (location.pathname != '/account/profile' || user.seniority != null)
                    ) {
                        handleRedirectInternal(history, 'subscription')
                        setAlert('Please Subscribe to Continue Further', 'success')
                    }
                }
            }
        } else {
            if (
                location.pathname &&
                location.pathname !== '/login' &&
                location.pathname !== '/registration' &&
                location.pathname !== '/subscription' &&
                location.pathname !== '/support' &&
                location.pathname !== '/switch' &&
                location.pathname !== '/forgot_password' &&
                !location.pathname.includes('/reset_password') &&
                location.pathname !== '/terms_of_use' &&
                !location.pathname.includes('/successPay')
            ) {
                handleRedirectInternal(history, 'login')
            }
        }
    }, [isAuthenticated, user, allBiddingPlan, location.pathname, membershipPlan])

    useEffect(() => {
        setCartProducts(search_allproducts.cartrecords.length ? search_allproducts.cartrecords : [])
    }, [search_allproducts])

    // useEffect(() => {
    //     let show = search_alluserinvoices.records.length ? true : false
    //     if (user?.membership) {
    //         show = true
    //     }
    //     setShowAuction(show)
    // }, [search_alluserinvoices, user])

    useEffect(() => {
        setCartProducts([])
        return () => {
            setCartProducts([])
        }
    }, [])

    useEffect(() => {
        if (responseStatusAuth) {
            if (responseStatusAuth.status === 'success') {
                // handleRedirectInternal(history, 'search')
            }
        }
    })

    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment') {
                if (responseStatusPayment.status === 'success') {
                    if (responseStatusPayment.data && responseStatusPayment.data.url) {
                        const newWindow = window.open(
                            responseStatusPayment.data.url,
                            '_self',
                            'noopener,noreferrer',
                        )
                        if (newWindow) newWindow.opener = null
                    }
                }
            }
        }
    }, [responseStatusPayment])

    useEffect(() => {
        if (searchValue) {
            const queryParams = new URLSearchParams(window.location.search)
            const check = queryParams.get('savedSearch')
            if (!check && isAuthenticated) handleRedirectInternal(history, `search`)
        }
    }, [searchValue])

    const onLogOut = () => {
        logout()
        setAlert('Logged out successfully', 'success')
        handleRedirectInternal(history, '')
        setanchormenu(null)
        setanchorcart(null)
        setSearchText('')
    }
    useEffect(() => {
        if (responseStatusUser?.status === 'success') {
            if (toggleDialog) {
                handleRedirectInternal(history, 'search')
            }
            setToggleDialog(false)
        }
    }, [responseStatusUser])
    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    const handleCart = (event) => {
        setanchorcart(event.currentTarget)
    }
    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setanchormenu(null)
        setanchorcart(null)
        if (history && path && path !== 'backdropClick') {
            handleRedirectInternal(history, path)
        }
    }

    const getSearchBarObjet = (value) => {
        return {
            limit: 12,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: {
                searchbar: {
                    value: value,
                    type: 'like',
                    field: 'p.title,p.desc_proc,cu.repossibility_desc,cu.bio_data',
                },
            },
        }
    }

    const handleSearchTextChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleSearchButtonClick = () => {
        setSearchValue(getSearchBarObjet(searchText))
        setState({ ...state, top: false })
        if (location.pathname != '/search') {
            handleRedirectInternal(history, 'search')
        }
    }

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            setSearchValue(getSearchBarObjet(searchText))
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
        }
    }

    useEffect(() => {
        if (searchValue && searchValue.filters && searchValue.filters.searchbar) {
            setSearchText(searchValue.filters.searchbar.value)
        }
    }, [searchValue])

    useEffect(() => {
        if (isAuthenticated) {
            let auctionFilter = {
                table: 'buynow',
                field: 'id',
                extraField: '',
                filters: {
                    buynow_autype: {
                        value: '',
                        type: 'in',
                        field: 'b.buynow_autype',
                    },
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'b.paid',
                    },
                    partial: {
                        value: '0',
                        type: 'in',
                        field: 'b.partial',
                    },
                    active: {
                        value: '2',
                        type: 'notin',
                        field: 'b.active',
                    },
                },
            }
            let buyNowFilter = {
                table: 'cart_temp',
                field: 'cart_id',
                extraField: '',
                filters: {
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'crt.paid',
                    },
                },
            }

            loadPendingCount(buyNowFilter, 'buynowCount')

            loadPendingCount(auctionFilter, 'auctionCount')
        }
    }, [isAuthenticated, history.location.pathname])

    const [count, setCount] = useState({
        auctionCount: 0,
        buynowCount: 0,
    })

    useEffect(() => {
        if (cartCount?.auctionCount) {
            setCount({ ...count, auctionCount: cartCount.auctionCount.totalRecords })
        }
        if (cartCount?.buynowCount) {
            setCount({ ...count, buynowCount: cartCount.buynowCount.totalRecords })
        }
    }, [cartCount])

    function ProtectedNavLink({ to, children, errorMessage = ERROR_MESSAGE, onClick, ...rest }) {
        const handleClick = (event) => {
            if (!isUserProfileUpdated && (user?.admin || (!user?.admin && user?.membership))) {
                /**
                 * block navigation if profile not update based on user. seniority field
                 */
                event.preventDefault()
                setAlert(errorMessage, 'error')

                handleRedirectInternal(history, 'account/profile')

                return
            }

            // if (onClick) {
            //     onClick()
            // }
            /**
             *  allowed → let NavLink handle navigation normally
             */
        }

        return (
            <NavLink to={to} activeClassName="active" onClick={handleClick} {...rest}>
                {children}
            </NavLink>
        )
    }

    const handleProtectedNavigation = (navigateFn) => {
        if (!isUserProfileUpdated && (user?.admin || (!user?.admin && user?.membership))) {
            setAlert(ERROR_MESSAGE, 'error')
            return
        }
        navigateFn()
    }

    const handleProtectedProfile = (navigateFn) => {
        if (!user?.admin && !user?.membership) {
            handleRedirectInternal(history, 'subscription')
            setAlert('Please Subscribe to Continue Further', 'success')
            return
        }
        navigateFn()
    }

    return (
        <>
            {useCustomMediaQuery('(min-width: 1024px)') ? (
                <>
                    {/* DESKTOP NAVIGATION */}
                    <Loaders name="home" isLoading={isLoading} />
                    <header className="mainHeader noPrint">
                        <div className="customContainer d-flex justify-content-between align-items-center h-100">
                            <div className="headLt d-flex justify-content-start align-items-center">
                                {isAuthenticated ? (
                                    <ProtectedNavLink
                                        to="/search"
                                        className="ASlogo"
                                        id="large_logo"
                                    >
                                        <img src={LOGO} alt={SITE_NAME} width="200" height="40" />
                                    </ProtectedNavLink>
                                ) : (
                                    <Link to="/login" className="ASlogo" id="large_logo">
                                        <img src={LOGO} alt={SITE_NAME} width="200" height="40" />
                                    </Link>
                                )}
                            </div>
                            <div className="menuRtOtr">
                                <div className="headRt deskNav d-flex justify-content-end align-items-center">
                                    <ul className="d-flex justify-content-start align-items-center">
                                        {isAuthenticated ? (
                                            !user?.admin ? (
                                                user?.membership && user?.membership_date ? (
                                                    <>
                                                        <li>
                                                            <ProtectedNavLink
                                                                to="/search"
                                                                id="header_auctions"
                                                            >
                                                                Offers
                                                            </ProtectedNavLink>
                                                        </li>{' '}
                                                        <li>
                                                            {' '}
                                                            <ProtectedNavLink
                                                                to="/auctions/ioi/ioi_request"
                                                                id="header_bids"
                                                            >
                                                                My Bids
                                                            </ProtectedNavLink>
                                                        </li>
                                                    </>
                                                ) : (
                                                    <li>
                                                        {' '}
                                                        <ProtectedNavLink
                                                            to="/auctions/all"
                                                            id="header_bids"
                                                        >
                                                            My Bids
                                                        </ProtectedNavLink>
                                                    </li>
                                                )
                                            ) : (
                                                <>
                                                    {/* {showAuction ? ( */}
                                                    <li>
                                                        <ProtectedNavLink
                                                            to="/search"
                                                            id="header_auctions"
                                                        >
                                                            Offers
                                                        </ProtectedNavLink>
                                                    </li>
                                                    {/* ) : null} */}
                                                </>
                                            )
                                        ) : null}

                                        {!isAuthenticated ? (
                                            <li>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/registration"
                                                    id="header_pricing"
                                                >
                                                    Pricing
                                                </NavLink>
                                            </li>
                                        ) : null}

                                        {isAuthenticated && (
                                            <>
                                                {user?.admin ? (
                                                    <>
                                                        {!user?.both_access ? (
                                                            !user.is_requested ? (
                                                                <li>
                                                                    <Button
                                                                        activeClassName="active"
                                                                        className="headerAuthBtn"
                                                                        onClick={() => {
                                                                            if (
                                                                                !isUserProfileUpdated
                                                                            ) {
                                                                                /**
                                                                                 * block navigation if profile not update based on user. seniority field
                                                                                 */

                                                                                setAlert(
                                                                                    ERROR_MESSAGE,
                                                                                    'error',
                                                                                )
                                                                            } else {
                                                                                setToggleDialog(
                                                                                    true,
                                                                                )
                                                                            }
                                                                        }}
                                                                        id="header_tg"
                                                                    >
                                                                        Become a TimeBidder
                                                                    </Button>
                                                                </li>
                                                            ) : null
                                                        ) : null}

                                                        <li>
                                                            <ProtectedNavLink
                                                                to="/seller/lots/open"
                                                                id="header_myauction"
                                                            >
                                                                My Offers
                                                            </ProtectedNavLink>
                                                        </li>

                                                        {user?.both_access && (
                                                            <li>
                                                                {' '}
                                                                <ProtectedNavLink
                                                                    to="/auctions/all"
                                                                    id="header_bids"
                                                                >
                                                                    My Bids
                                                                </ProtectedNavLink>
                                                            </li>
                                                        )}
                                                        {user?.both_access ? (
                                                            <>
                                                                <li className="mr-0">
                                                                    <ProtectedNavLink
                                                                        to="/singlecart"
                                                                        id="header_myauction"
                                                                    >
                                                                        <Button
                                                                            className="text-light hdrIcon"
                                                                            aria-controls="simple-cart"
                                                                            aria-haspopup="true"
                                                                            // onClick={handleCart}
                                                                            id="header_cart"
                                                                        >
                                                                            <Badge
                                                                                badgeContent={
                                                                                    count.buynowCount +
                                                                                    count.auctionCount
                                                                                }
                                                                                color="primary"
                                                                            >
                                                                                <span className="material-icons">
                                                                                    shopping_cart
                                                                                </span>
                                                                            </Badge>
                                                                        </Button>
                                                                    </ProtectedNavLink>
                                                                </li>
                                                            </>
                                                        ) : null}
                                                    </>
                                                ) : (
                                                    <>
                                                        {!user?.both_access ? (
                                                            !user.is_requested ? (
                                                                user?.membership ? (
                                                                    <li>
                                                                        <Button
                                                                            activeClassName="active"
                                                                            className="headerAuthBtn"
                                                                            onClick={() => {
                                                                                if (
                                                                                    !isUserProfileUpdated
                                                                                ) {
                                                                                    setAlert(
                                                                                        ERROR_MESSAGE,
                                                                                        'error',
                                                                                    )
                                                                                } else {
                                                                                    setToggleDialog(
                                                                                        true,
                                                                                    )
                                                                                }
                                                                            }}
                                                                            id="header_tg"
                                                                        >
                                                                            Become a TimeGiver
                                                                        </Button>
                                                                    </li>
                                                                ) : null
                                                            ) : null
                                                        ) : null}
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {isAuthenticated ? (
                                            <>
                                                {user?.admin ? (
                                                    <>
                                                        <li>
                                                            <Button
                                                                className="headerAuthBtn"
                                                                aria-controls="simple-menu"
                                                                aria-haspopup="true"
                                                                onClick={handleMenu}
                                                                id="header_user"
                                                            >
                                                                <span className="material-icons-outlined">
                                                                    person
                                                                </span>
                                                                {user.first_name +
                                                                    ' ' +
                                                                    user.last_name}
                                                                {/* My Account */}
                                                                <span className="material-icons">
                                                                    arrow_drop_down
                                                                </span>
                                                            </Button>
                                                        </li>
                                                    </>
                                                ) : (
                                                    <>
                                                        {
                                                            <li className="mr-0">
                                                                <ProtectedNavLink
                                                                    to="/singlecart"
                                                                    id="header_myauction"
                                                                >
                                                                    <Button
                                                                        className="text-light hdrIcon"
                                                                        aria-controls="simple-cart"
                                                                        aria-haspopup="true"
                                                                        // onClick={handleCart}
                                                                        id="header_cart"
                                                                    >
                                                                        <Badge
                                                                            badgeContent={
                                                                                count.buynowCount +
                                                                                count.auctionCount
                                                                            }
                                                                            color="primary"
                                                                        >
                                                                            <span className="material-icons">
                                                                                shopping_cart
                                                                            </span>
                                                                        </Badge>
                                                                    </Button>
                                                                </ProtectedNavLink>
                                                            </li>
                                                        }

                                                        <li>
                                                            <Button
                                                                className="headerAuthBtn"
                                                                id="header_user_detail"
                                                                aria-controls="simple-menu"
                                                                aria-haspopup="true"
                                                                onClick={handleMenu}
                                                            >
                                                                <span className="material-icons-outlined">
                                                                    person
                                                                </span>
                                                                {user.first_name +
                                                                    ' ' +
                                                                    user.last_name}
                                                                {/* My Account */}
                                                                <span className="material-icons">
                                                                    arrow_drop_down
                                                                </span>
                                                            </Button>
                                                        </li>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <li>
                                                    <Button
                                                        className="headerAuthBtn"
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'login')
                                                        }
                                                    >
                                                        <span className="material-icons-outlined">
                                                            person
                                                        </span>{' '}
                                                        Login / Sign up
                                                    </Button>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </header>
                    {toggleUnpaid ? (
                        <div
                            className="header-invoice"
                            onClick={() => {
                                handleRedirectInternal(history, 'invoices/partial')
                            }}
                        >
                            You have an unpaid invoice. Please click
                            <span
                                className="hyper-link"
                                onClick={() => {
                                    handleRedirectInternal(history, 'invoices/partial')
                                }}
                            >
                                here
                            </span>
                            to complete your transaction.
                        </div>
                    ) : null}
                </>
            ) : (
                <>
                    {/* MOBILE / TAB NAVIGATION */}
                    <header className="mainHeader mockHeader customContainer d-flex justify-content-between align-items-center">
                        <div className="headLt d-flex justify-content-start">
                            <ProtectedNavLink to="/">
                                <img src={LOGO} alt={SITE_NAME} width="130" height="25" />
                            </ProtectedNavLink>
                        </div>
                        <div className="headRt">
                            <ul className="navMobile d-flex justify-content-start ml-auto align-items-center">
                                {!location.pathname.includes('/login') &&
                                !location.pathname.includes('/registration') &&
                                !location.pathname.includes('/subscription') ? (
                                    <li>
                                        <Button
                                            id="header_user_search"
                                            className="respSearchBtn"
                                            onClick={toggleDrawer('top', true)}
                                        >
                                            <span className="material-icons">search</span>
                                        </Button>
                                    </li>
                                ) : (
                                    ''
                                )}
                                {isAuthenticated &&
                                    ((user?.admin && user?.both_access) || !user?.admin) && (
                                        <li className="headCart">
                                            <Link to="/cart" style={{ display: 'flex' }}>
                                                {count.buynowCount + count.auctionCount !== 0 ? (
                                                    <Badge
                                                        badgeContent={
                                                            count.buynowCount +
                                                                count.auctionCount !==
                                                            0
                                                                ? count.buynowCount +
                                                                  count.auctionCount
                                                                : null
                                                        }
                                                        count={
                                                            count.buynowCount + count.auctionCount
                                                        }
                                                        color="primary"
                                                    >
                                                        <span className="material-icons">
                                                            shopping_cart
                                                        </span>
                                                    </Badge>
                                                ) : (
                                                    <span className="material-icons">
                                                        shopping_cart
                                                    </span>
                                                )}
                                            </Link>
                                        </li>
                                    )}

                                <li>
                                    <Button
                                        className="respNavBtn"
                                        id="header_menu"
                                        onClick={toggleDrawer('right', true)}
                                    >
                                        <span className="material-icons">menu</span>
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    </header>

                    <React.Fragment>
                        <SwipeableDrawer
                            className="respHeaderSearch"
                            anchor={'top'}
                            open={state['top']}
                            disableBackdropTransition={!iOS}
                            disableDiscovery={iOS}
                            disableSwipeToOpen={false}
                            onClose={toggleDrawer('top', false)}
                            onOpen={toggleDrawer('top', true)}
                        >
                            <div className="form-inline my-2 my-lg-0 headerSearchForm">
                                <input
                                    className="form-control"
                                    type="search"
                                    placeholder="search"
                                    aria-label="Search"
                                    value={searchText}
                                    onChange={handleSearchTextChange}
                                    onKeyDown={handleSearchKeyDown}
                                />
                                <Button
                                    id="header_searchButton"
                                    className="btn"
                                    onClick={handleSearchButtonClick}
                                >
                                    <span className="material-icons">search</span>
                                </Button>
                            </div>
                        </SwipeableDrawer>
                    </React.Fragment>

                    <React.Fragment>
                        <SwipeableDrawer
                            className="headerDrawer"
                            anchor={'right'}
                            open={state['right']}
                            disableBackdropTransition={!iOS}
                            disableDiscovery={iOS}
                            disableSwipeToOpen={false}
                            onClose={toggleDrawer('right', false)}
                            onOpen={toggleDrawer('right', true)}
                        >
                            <div className="headRt respNav d-flex justify-content-start align-items-center">
                                <div className="naLogoHead d-flex justify-content-between align-items-center">
                                    <Link to="/">
                                        <img src={LOGO} alt={SITE_NAME} height="60" />
                                    </Link>
                                    <Button
                                        id="header_clear"
                                        className="headDrawerClose"
                                        onClick={toggleDrawer('right', false)}
                                    >
                                        <span className="material-icons">clear</span>
                                    </Button>
                                </div>
                                <Divider />
                                {isAuthenticated && (
                                    <ListItem
                                        button
                                        onClick={() =>
                                            handleProtectedProfile(() => {
                                                handleRedirectInternal(history, 'account/profile')
                                            })
                                        }
                                        activeClassName="active"
                                    >
                                        <span className="material-icons">person</span>
                                        {'My Account'}
                                    </ListItem>
                                )}
                                {isAuthenticated ? (
                                    user?.admin ? (
                                        <>
                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    to="/seller/lots/open"
                                                    onClose={toggleDrawer('right', false)}
                                                >
                                                    <span className="material-icons">gavel</span>
                                                    My Offers
                                                </ProtectedNavLink>
                                            </ListItem>
                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    to="/search"
                                                    onClose={toggleDrawer('right', false)}
                                                >
                                                    <span className="material-icons">category</span>
                                                    Offers
                                                </ProtectedNavLink>
                                            </ListItem>
                                            {user?.both_access ? (
                                                <>
                                                    <ListItem
                                                        button
                                                        onClick={toggleDrawer('right', false)}
                                                    >
                                                        <ProtectedNavLink to="/auctions/all">
                                                            <span className="material-icons">
                                                                gavel
                                                            </span>
                                                            {'My Bids'}
                                                        </ProtectedNavLink>
                                                    </ListItem>
                                                    <ListItem
                                                        button
                                                        onClick={toggleDrawer('right', false)}
                                                    >
                                                        <ProtectedNavLink
                                                            activeClassName="active"
                                                            to="/watchlist/watchlist"
                                                        >
                                                            <span className="material-icons">
                                                                favorite
                                                            </span>
                                                            {'My Favorites'}
                                                        </ProtectedNavLink>
                                                    </ListItem>
                                                    <ListItem
                                                        button
                                                        onClick={toggleDrawer('right', false)}
                                                    >
                                                        <ProtectedNavLink
                                                            activeClassName="active"
                                                            to="/purchases/buynow"
                                                        >
                                                            <span className="material-icons">
                                                                shopping_basket
                                                            </span>
                                                            {'My Purchases'}
                                                        </ProtectedNavLink>
                                                    </ListItem>
                                                    {user?.membership_period == 'five_yearly' ? (
                                                        <ListItem
                                                            button
                                                            onClick={toggleDrawer('right', false)}
                                                        >
                                                            <ProtectedNavLink
                                                                activeClassName="active"
                                                                to="/purchases/overture"
                                                            >
                                                                <span className="material-icons">
                                                                    shopping_basket
                                                                </span>
                                                                {'My Overtures'}
                                                            </ProtectedNavLink>
                                                        </ListItem>
                                                    ) : null}

                                                    <ListItem
                                                        button
                                                        onClick={toggleDrawer('right', false)}
                                                    >
                                                        <ProtectedNavLink
                                                            activeClassName="active"
                                                            to="/invoices/all"
                                                        >
                                                            <span className="material-icons">
                                                                receipt
                                                            </span>
                                                            {'My Invoices'}
                                                        </ProtectedNavLink>
                                                    </ListItem>

                                                    <ListItem
                                                        button
                                                        onClick={toggleDrawer('right', false)}
                                                    >
                                                        <ProtectedNavLink
                                                            activeClassName="active"
                                                            to="/payments/transactions"
                                                        >
                                                            <span className="material-icons">
                                                                credit_card
                                                            </span>
                                                            {'My Payments'}
                                                        </ProtectedNavLink>
                                                    </ListItem>
                                                    <ListItem
                                                        button
                                                        onClick={toggleDrawer('right', false)}
                                                    >
                                                        <ProtectedNavLink
                                                            activeClassName="active"
                                                            to="/saved_search"
                                                        >
                                                            <span className="material-icons">
                                                                bookmark
                                                            </span>
                                                            {'Saved Search'}
                                                        </ProtectedNavLink>
                                                    </ListItem>
                                                </>
                                            ) : null}
                                        </>
                                    ) : (
                                        <>
                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink to="/auctions/all">
                                                    <span className="material-icons">gavel</span>
                                                    {'My Bids'}
                                                </ProtectedNavLink>
                                            </ListItem>

                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    activeClassName="active"
                                                    to="/search"
                                                    onClose={toggleDrawer('right', false)}
                                                >
                                                    <span className="material-icons">category</span>
                                                    {'Offers'}
                                                </ProtectedNavLink>
                                            </ListItem>
                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    activeClassName="active"
                                                    to="/watchlist/watchlist"
                                                >
                                                    <span className="material-icons">favorite</span>
                                                    {'My Favorites'}
                                                </ProtectedNavLink>
                                            </ListItem>
                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    activeClassName="active"
                                                    to="/purchases/buynow"
                                                >
                                                    <span className="material-icons">
                                                        shopping_basket
                                                    </span>
                                                    {'My Purchases'}
                                                </ProtectedNavLink>
                                            </ListItem>
                                            {user?.membership_period == 'five_yearly' ? (
                                                <ListItem
                                                    button
                                                    onClick={toggleDrawer('right', false)}
                                                >
                                                    <ProtectedNavLink
                                                        activeClassName="active"
                                                        to="/purchases/overture"
                                                    >
                                                        <span className="material-icons">
                                                            shopping_basket
                                                        </span>
                                                        {'My Overtures'}
                                                    </ProtectedNavLink>
                                                </ListItem>
                                            ) : null}

                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    activeClassName="active"
                                                    to="/invoices/all"
                                                >
                                                    <span className="material-icons">receipt</span>
                                                    {'My Invoices'}
                                                </ProtectedNavLink>
                                            </ListItem>

                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    activeClassName="active"
                                                    to="/payments/transactions"
                                                >
                                                    <span className="material-icons">
                                                        credit_card
                                                    </span>
                                                    {'My Payments'}
                                                </ProtectedNavLink>
                                            </ListItem>
                                            <ListItem button onClick={toggleDrawer('right', false)}>
                                                <ProtectedNavLink
                                                    activeClassName="active"
                                                    to="/saved_search"
                                                >
                                                    <span className="material-icons">bookmark</span>
                                                    {'Saved Search'}
                                                </ProtectedNavLink>
                                            </ListItem>
                                        </>
                                    )
                                ) : (
                                    <>
                                        <ListItem button onClick={toggleDrawer('right', false)}>
                                            <NavLink
                                                to="/login"
                                                ActiveclassName="active"
                                                onClose={toggleDrawer('right', false)}
                                            >
                                                <span className="material-icons">login</span>
                                                {'Login'}
                                            </NavLink>
                                        </ListItem>
                                        <ListItem button onClick={toggleDrawer('right', false)}>
                                            <NavLink
                                                to="/registration"
                                                ActiveclassName="active"
                                                onClose={toggleDrawer('right', false)}
                                            >
                                                <span className="material-icons">
                                                    app_registration
                                                </span>
                                                {'Sign up'}
                                            </NavLink>
                                        </ListItem>
                                    </>
                                )}

                                <ul className="navRespLinks mt-0">
                                    <ListItem button onClick={toggleDrawer('right', false)}>
                                        {/* <NavLink ActiveclassName="active" to="/about">
                                            <span className="material-icons">info</span>
                                            {'About'}
                                        </NavLink> */}
                                        <a
                                            id="footer_about"
                                            href="https://www.timetogive.network/about"
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <span className="material-icons">info</span>
                                            {'About'}
                                        </a>
                                    </ListItem>

                                    {!isAuthenticated ? (
                                        <ListItem button onClick={toggleDrawer('right', false)}>
                                            <NavLink
                                                activeClassName="active"
                                                to="/subscription"
                                                id="header_pricing"
                                            >
                                                <span className="material-icons">
                                                    monetization_on
                                                </span>
                                                {'Pricing'}
                                            </NavLink>
                                        </ListItem>
                                    ) : null}
                                </ul>

                                {isAuthenticated && (
                                    <ListItem
                                        onClick={() => {
                                            toggleDrawer('right', false)
                                            onLogOut()
                                        }}
                                        className=""
                                        button
                                        // onClick={() => onLogOut()}
                                    >
                                        <span className="material-icons">power_settings_new</span>
                                        {'Logout'}
                                    </ListItem>
                                )}
                            </div>
                        </SwipeableDrawer>
                    </React.Fragment>
                </>
            )}
            <Popover
                anchorEl={anchorcart}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id="simple-cart"
                keepMounted
                class={`headerDropMenu ${document.body.dir === 'rtl' && 'rtl'}`}
                open={Boolean(anchorcart)}
                onClose={handleClose}
            >
                <ul className={`headerDropMenu ${document.body.dir === 'rtl' && 'rtl'}`}>
                    <ListItem
                        button
                        onClick={() => {
                            toggleDrawer('right', false)
                            handleClose(history, 'buynowcart')
                        }}
                        id="header_buynowcart"
                    >
                        <Badge badgeContent={count.buynowCount} color="primary">
                            <span className="material-icons">shopping_bag</span>
                        </Badge>
                        {'Buy now cart'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            toggleDrawer('right', false)
                            handleClose(history, 'cart')
                        }}
                        id="header_auctioncart"
                    >
                        <Badge badgeContent={count.auctionCount} color="primary">
                            <span className="material-icons">gavel</span>
                        </Badge>

                        {'Auction cart'}
                    </ListItem>
                </ul>
            </Popover>
            <Popover
                id={'simple-menu'}
                open={Boolean(anchormenu)}
                anchorEl={anchormenu}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <ul className={`headerDropMenu ${document.body.dir === 'rtl' && 'rtl'}`}>
                    <ListItem
                        button
                        onClick={() =>
                            handleProtectedProfile(() => {
                                toggleDrawer('right', false)
                                handleClose(history, 'account/profile')
                            })
                        }
                        id="header_profile"
                    >
                        {'My Account'}
                    </ListItem>
                    {user?.admin ? (
                        <>
                            <ListItem
                                button
                                onClick={() =>
                                    handleProtectedNavigation(() => {
                                        toggleDrawer('right', false)
                                        handleClose(history, 'seller/lots/ioi/ioi_request')
                                    })
                                }
                                id="header_mybids"
                            >
                                {'My Offers'}
                            </ListItem>

                            {user?.both_access ? (
                                <>
                                    <ListItem
                                        button
                                        onClick={() =>
                                            handleProtectedNavigation(() => {
                                                toggleDrawer('right', false)
                                                handleClose(history, 'auctions/ioi/ioi_request')
                                            })
                                        }
                                        id="header_mybids"
                                    >
                                        {'My Bids'}
                                    </ListItem>
                                    <Popover
                                        anchorEl={anchorcart}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        id="simple-cart"
                                        keepMounted
                                        class={`headerDropMenu ${
                                            document.body.dir === 'rtl' && 'rtl'
                                        }`}
                                        open={Boolean(anchorcart)}
                                        onClose={handleClose}
                                    >
                                        <ul
                                            className={`headerDropMenu ${
                                                document.body.dir === 'rtl' && 'rtl'
                                            }`}
                                        >
                                            <ListItem
                                                button
                                                onClick={() =>
                                                    handleProtectedNavigation(() => {
                                                        toggleDrawer('right', false)
                                                        handleClose(history, 'buynowcart')
                                                    })
                                                }
                                                id="header_buynowcart"
                                            >
                                                <Badge
                                                    badgeContent={count.buynowCount}
                                                    color="primary"
                                                >
                                                    <span className="material-icons">
                                                        shopping_bag
                                                    </span>
                                                </Badge>
                                                {'Buy now cart'}
                                            </ListItem>
                                            <ListItem
                                                button
                                                onClick={() =>
                                                    handleProtectedNavigation(() => {
                                                        toggleDrawer('right', false)
                                                        handleClose(history, 'cart')
                                                    })
                                                }
                                                id="header_auctioncart"
                                            >
                                                <Badge
                                                    badgeContent={count.auctionCount}
                                                    color="primary"
                                                >
                                                    <span className="material-icons">gavel</span>
                                                </Badge>

                                                {'Auction cart'}
                                            </ListItem>
                                        </ul>
                                    </Popover>
                                </>
                            ) : null}
                        </>
                    ) : (
                        <ListItem
                            button
                            onClick={() =>
                                handleProtectedNavigation(() => {
                                    toggleDrawer('right', false)
                                    handleClose(history, 'auctions/ioi/ioi_request')
                                })
                            }
                            id="header_mybids"
                        >
                            {'My Bids'}
                        </ListItem>
                    )}
                    <ListItem
                        button
                        onClick={() => {
                            toggleDrawer('right', false)
                            handleClose(history, 'support')
                        }}
                        id="support_us"
                    >
                        {'Support'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            toggleDrawer('right', false)
                            onLogOut()
                        }}
                        id="header_logout"
                    >
                        {'Logout'}
                    </ListItem>
                </ul>
            </Popover>
            <CustomDialog
                title={`Confirm to became a ${user?.admin ? 'Time Bidder' : 'Time Giver'}`}
                open={toggleDialog}
                function={changeDialogStatus}
            >
                <h5>{t('Are you sure you want to proceed with this action?')}</h5>
                <div className="actionWrapper">
                    <Button id="cancel" onClick={() => setToggleDialog(false)}>
                        {t('Cancel')}
                    </Button>
                    <PrimaryButton
                        onClick={() => {
                            if (user?.admin) {
                                setToggleDialog(false)
                                handleRedirectInternal(history, 'subscription')
                            } else {
                                updateProfile(
                                    {
                                        email: user?.email,
                                        id: user?.id,
                                        last_name: user?.last_name,
                                        first_name: user?.first_name,
                                        phone: user?.phone,
                                        address1: user?.address,
                                        city: user?.city,
                                        state: user?.state,
                                        zip: user?.zip,
                                        admin: 1,
                                        emp_type: 'seller',
                                        both_access: 1,
                                    },

                                    // false,
                                    // 'requestUpdate',
                                )
                            }
                        }}
                        id="confirm_bid_submit"
                        type="button"
                        label={t('Submit')}
                    />
                </div>
            </CustomDialog>
            {/* <CustomDialog
                title={`You have unpaid invoice`}
                open={toggleUnpaid}
                function={changeDialogUnpaidStatus}
            >
                <h5>{t('Please make the payment for the unpaid invoice')}</h5>
                <div className="actionWrapper">
                    <Button id="cancel" onClick={() => setToggleUnpaid(false)}>
                        {t('Cancel')}
                    </Button>
                    <PrimaryButton
                        onClick={() => {
                            setToggleUnpaid(false)
                            handleRedirectInternal(history, 'invoices/partial')
                        }}
                        id="invoice"
                        type="button"
                        label={t('Proceed')}
                    />
                </div>
            </CustomDialog> */}
            <BidHistory />
        </>
    )
}
export default Header
